<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<van-collapse v-model="activeName" accordion>
		  <van-collapse-item v-for="(item,index) in listData" :key="index"  :title="item.title" :name="index">
			  <div style="padding: 20rpx;" v-for="(itemSon,index2) in item.desc" :key="index2" >
					<div class="text-bold text-xl">{{index2+1}}:{{itemSon.title}}</div>
					<div class="text-grey text-xl">{{itemSon.detail}}</div>
			  </div>
		  </van-collapse-item>
		</van-collapse>
	</joy-page>
</template>

<script>
	export default{
		created() {
			this.loadData();
		},
		data(){
			return{
				activeName: '',
				joyPageStatus:'',
				listData:'',
			}
		},
		methods:{
			loadData(){
				try{
					this.joyPageStatus = 'loading';
					this.$axios.get('site/help').then(res => {
						this.joyPageStatus = 'success';
						if(res.data.code==200){
							this.listData=res.data.data;
						}else{
							this.$toast.fail(res.data.msg)
						}
					})
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				}
			},
		},
		
	}
	
</script>

<style scoped="scoped">
</style>
